/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import backgroundImg from '../../assets/images/background.png';
import { 
  PreviewPanorama, Wrapper, Step1Right, Logo, Step1Left, Step2FadeInOut, Container, Step3FadeInOut,
 StepAllFadeInO 
} from './index.style'


const LoadingComponent = ({ 
  className = "", forceLogoOnly = false, redirect = true, redirectPath = '/splash', dark = false,
  previewPanorama = {backgroundImg}
}) => {
  const history = useHistory();
  const [ fadeEnd, setFadeEnd ] = useState(false);
  const [ showBgLogo, setShowBgLogo ] = useState(true);

  const [stepAnimation, setStepAnimation] = useState(1)
  const redirectEffect = () => { redirect && setTimeout(() => { history.replace(redirectPath) }, 9500) }
  React.useEffect(redirectEffect, [])

  useEffect(() => {
    if(redirect) {
      if(stepAnimation === 1) setTimeout(() => {setStepAnimation(2);}, 2500);
      if(stepAnimation === 2) setTimeout(() => {setStepAnimation(3);}, 3100);
      if(stepAnimation === 3) setTimeout(() => {setShowBgLogo(false);}, 1000);
    }

    if(stepAnimation === 1 && redirect) setTimeout(() => { setFadeEnd(true) }, 8300)
    
  }, [stepAnimation])
  const loadingStyle = { position: 'absolute', backgroundImage: `url(${backgroundImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: "center" }
  return (
    <div className={className}>
      {previewPanorama !== "" && <PreviewPanorama className={`${fadeEnd && 'fadeEnd'} ${className}`} style={loadingStyle}></PreviewPanorama>}
      <Container 
        dark={dark}
        className={`relative vh-100 d-flex justify-content-center align-items-center z-index-20 no-touch ${className} ${fadeEnd && 'fadeEnd'}`} 
        style={{width: '100%' }}
      >
        <Wrapper>
          {!forceLogoOnly && stepAnimation === 1 &&
            <>
              <Step1Left delay={.5} />
              <Step1Right delay={.5}/>  
            </>
          }
          {!forceLogoOnly && stepAnimation === 2 &&
            <>
              <Step1Left delay={.8} anim={"step2"}/>
              <Step1Right delay={.9} anim={"step2"}/> 
              <Step2FadeInOut /> 
            </>
          }
          {!forceLogoOnly && stepAnimation === 3 &&
            <> 
              <Step3FadeInOut />  
            </>
          }
          {!forceLogoOnly && showBgLogo &&
            <> 
              <StepAllFadeInO /> 
            </>
          }
          {forceLogoOnly &&
            <Logo />
          }
        </Wrapper>
      </Container>
    </div>
  )
}

export default React.memo(LoadingComponent)
